import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { GlobalDataContextProvider } from "./custom-hooks/use-global-data";
import { AuthContextProvider } from "./custom-hooks/use-auth-context";
import "react-toastify/dist/ReactToastify.css";
import "./i18n";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 1000,
      staleTime: process.env.APP_ENV === "admin" ? 900000 : 90000,
    },
  },
});

root.render(
  <React.StrictMode>
    <GlobalDataContextProvider>
      <AuthContextProvider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ToastContainer />
            <App />
          </QueryClientProvider>
        </BrowserRouter>
      </AuthContextProvider>
    </GlobalDataContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
